import React, { useState, useCallback, useMemo } from "react";
import { Button, Col, Input, Row } from "antd";
import { AutoResizeTextArea } from "../../AutoResizeTextArea";
import styles from "./style.scss";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { selectAdData } from "../../../routes/AdForm/adForm.ducks";

import { CategoryName, ModuleName } from "../../../models";

import { api, checkEmptyObject } from "../../../services";
import { mapCategoryToEn, mapModuleToEn } from "../../../routes/LanguageMapper";

export interface SuggestedAiDescriptionProps {
  title: string;
  placeholder: string;
  isDisabled: boolean;
  size: "large" | "small" | "default";
  field: string;
  value: any;
  isRequired: boolean;
  onChange: (value: any) => void;
}

const SuggestedAiDescription = (props: SuggestedAiDescriptionProps) => {
  const {
    title,
    placeholder,
    isDisabled,
    size,
    field,
    value,
    onChange,
    isRequired,
  } = props;

  const selectedData = useSelector(selectAdData);

  const [suggestedDescription, setsuggestedDescription] = useState(value && value[field] ? value[field] : "");
  const [isLoading, setIsLoading] = useState(false);
  const [isAiGenerated, setIsAiGenerated] = useState(false);
  const [disabled, setDisabled] = useState(false);


  const eligibleForSuggestedDescription = useMemo(() => {
    if (!selectedData || !selectedData.module || !selectedData.category) return false;

    return (
      mapModuleToEn(selectedData.module) === ModuleName.vehicles &&
      mapCategoryToEn(selectedData.category, mapModuleToEn(selectedData.module)) === CategoryName.car &&
      selectedData.makeId &&
      selectedData.modelId &&
      selectedData.makeYear &&
      selectedData.fuel
    );
  }, [selectedData]);

  const handleChange = element => {
    const { value } = element.target;
    setsuggestedDescription(value);
    onChange({ [field]: value });
  };

  const handleFetchsuggestedDescription = useCallback(async () => {
    setIsLoading(true);
    setDisabled(true);

    ReactGA.event({
      category: "AI alat",
      action: "Click",
      label: "Generiraj opis oglasa"
    });

    try {
      const res = await api.AI.suggestedDescription({
        ...selectedData,
        module: mapModuleToEn(selectedData.module),
        category: mapCategoryToEn(selectedData.category, mapModuleToEn(selectedData.module)),
      });
      if (!checkEmptyObject(res) && res.message) return;
      setsuggestedDescription(res.message);
      setIsAiGenerated(true);
      onChange({
        [field]: res.message,
        aiDescription: res.message
      });
      setIsLoading(false);
      setDisabled(false);

    } catch (e) {
      console.error(e);
      setIsLoading(false);
      setDisabled(false);
    }

  }, [selectedData]);

  return <Row>
    <Col>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
    </Col>
    <Col span={24}>
      <Row>
        <Col>
          <div className={styles.loadingTextContainer}>
            {isLoading ? (
              <span className={styles.loadingText}>
                <p> Generiranje opisa pomoću umjetne inteligencije je u tijeku. Molimo pričekajte – ovo može potrajati do 30 sekundi.</p>
              </span>
            ) : null}
            <AutoResizeTextArea
              value={suggestedDescription}
              placeholder={placeholder}
              onChange={handleChange}
              disabled={isDisabled || disabled}
              autoSize={{ minRows: 5, maxRows: 25 }}
              className={styles.mobileInput}
            />

          </div>
        </Col>
      </Row>
    </Col>
    <Col xs={24} md={16}>
      {isAiGenerated ? <p className={styles.suggestedDescription}>
        {"Ovaj opis je generiran pomoću umjetne inteligencije. Molimo te da ga pregledaš i po potrebi dodatno urediš, jer su moguće pogreške."}
      </p> : null}
    </Col>
    {eligibleForSuggestedDescription ? <Col xs={24} md={8}>
      <Button
        type="primary"
        onClick={handleFetchsuggestedDescription}
        className={styles.button}
        disabled={isDisabled}
        loading={isLoading}
      >
        {"Predloži opis pomoću AI"}
      </Button>
    </Col> : null}
  </Row >
};

export default SuggestedAiDescription;



// WEBPACK FOOTER //
// ./src/components/FormControls/SuggestedAiDescription/index.tsx